import { render, staticRenderFns } from "./SchoolLevelSet.vue?vue&type=template&id=3d462485&scoped=true"
import script from "./SchoolLevelSet.vue?vue&type=script&lang=js"
export * from "./SchoolLevelSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d462485",
  null
  
)

export default component.exports